// The contractors columns the app reads at sign-in. The quote logo and QuickBooks token fields are not included,
// so signing in doesn't download them.
export const PROFILE_COLUMNS = "id, name, industry, client_type, qb_realm_id, consent_accepted_at, consent_version, cost_preset, pays_people_per_job";

// Loads the signed-in business's profile row. If a column isn't there yet (a migration not applied) the first
// query fails, so it falls back to every column and sign-in still works.
export async function fetchProfile(client, userId) {
  const first = await client.from("contractors").select(PROFILE_COLUMNS).eq("id", userId).single();
  if (!first.error && first.data) return first.data;
  const { data } = await client.from("contractors").select("*").eq("id", userId).single();
  return data;
}
